import { Col, Skeleton, useEntrance, useTheme } from "@rally/ui-kit";
import type { ReactNode } from "react";
import { say } from "../../localization/say.ts";

export function Words({ fade, children }: { fade: boolean; children: ReactNode }) {
  const theme = useTheme();

  const entrance = useEntrance("fade", "fast");
  return <Col style={{ gap: theme.space[4], opacity: fade ? (entrance as never) : 1 }}>{children}</Col>;
}

export function Coming() {
  const theme = useTheme();

  return (
    <Col style={{ gap: theme.space[4] }} testID="record-coming" accessibilityLabel={say("chat.opening")}>
      {(["88%", "56%", "72%"] as const).map((width) => (
        <Col key={width} style={{ flexDirection: "row", gap: theme.space[3] }} aria-hidden>
          <Skeleton width={32} height={32} circle />
          <Col style={{ flex: 1, gap: 2 }}>
            <Skeleton width="30%" height={14} />
            <Skeleton width={width} height={16} />
          </Col>
        </Col>
      ))}
    </Col>
  );
}
